import { Stack, Typography, Box, Link } from "@mui/material";

const NoItems = ({ title, description }) => {
    // Replace URLs with clickable links
    const renderDescription = (text) => {
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        const parts = text.split(urlRegex);

        return parts.map((part, index) => {
            if (urlRegex.test(part)) {
                return (
                    <Link
                        key={index}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{ color: "#1976d2", textDecoration: "underline" }}
                    >
                        {part}
                    </Link>
                );
            }
            return <span key={index}>{part}</span>;
        });
    };

    return (
        <Box sx={{ border: "1px dashed", borderColor: "#6F8E9A", borderRadius: "16px" }}>
            <Stack spacing={2} alignItems="center" justifyContent="center" sx={{ padding: 2 }}>
                <Typography variant="subtitle2" color="#6F8E9A">
                    {title}
                </Typography>
                <Typography variant="body2" color="#6F8E9A" textAlign="center">
                    {renderDescription(description)}
                </Typography>
            </Stack>
        </Box>
    );
};

export default NoItems;
